import { useMutation, useQueryClient } from '@tanstack/react-query';
// import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { updateUserRoleAPI } from 'src/api';
import { ToastStyled } from 'src/components';
import type {
  MembershipRole,
  MembershipStatus,
  OrgQueriesData,
} from 'src/types';

export const useUpdateUserRole = () => {
  // const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      email,
      role,
      status,
    }: {
      id: string;
      email: string;
      role: MembershipRole;
      status: MembershipStatus;
    }) => updateUserRoleAPI(id, email, role, status),
    onSuccess: (_, variables) => {
      toast.custom((toastBlock) => (
        <ToastStyled
          variant='success'
          handleClose={() => toast.dismiss(toastBlock)}
        >
          User role updated successfully!
        </ToastStyled>
      ));

      // update the user role in the cache
      queryClient.setQueriesData(
        {
          queryKey: ['orgUsers'],
          type: 'all',
        },
        (
          oldData:
            | { pages: OrgQueriesData[]; pageParams: number[] }
            | undefined,
        ): { pages: OrgQueriesData[]; pageParams: number[] } | undefined => {
          if (!oldData) {
            return undefined;
          }

          const updatedPages = oldData.pages.map((page) => {
            return {
              ...page,
              users: page.users.map((user) => {
                if (user.id === variables.id) {
                  return { ...user, role: variables.role };
                }
                return user;
              }),
            };
          });

          return { pages: updatedPages, pageParams: oldData.pageParams };
        },
      );
    },
    onError: () => {
      toast.custom((toastBlock) => (
        <ToastStyled
          variant='error'
          handleClose={() => toast.dismiss(toastBlock)}
        >
          Failed to update user role.
        </ToastStyled>
      ));
    },
  });
};
